import React from 'react';
import PropTypes from 'prop-types';
import {
  EVTypography,
  EVButton,
  EVDragIndicatorOutlinedIcon,
  EVPaper,
} from '@eagleview/ev-comp-library';
import Draggable from 'react-draggable';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import * as authorizeAction from 'features/authorize/Authorize.actions';
import { useDispatch } from 'react-redux';
import useStyles from './SignoutBannerStyle';

const SignoutBanner = (props) => {
  const {
    t, userDetails, bounds, position, handleDrag, isSignOutDisabled,
  } = props;
  const classes = useStyles();
  const { firstName, lastName } = userDetails;
  const dispatch = useDispatch();
  const expireUser = () => {
    dispatch(authorizeAction.expireGuid());
    dispatch(authorizeAction.setSignOutDisabled(true));
  };
  const signOutText = `${t('SignedInAs')} ${firstName} ${lastName}`;

  return (
    <Draggable
      bounds={bounds}
      position={position}
      onDrag={handleDrag}
      handle=".handle"
    >
      <EVPaper id="signout-banner" className={classes.container}>
        <div className={`handle ${classes.drag}`}>
          <EVDragIndicatorOutlinedIcon className={classes.icon} />
          <EVTypography id="signout-banner-text" className={classes.text}>
            {signOutText}
          </EVTypography>
        </div>
        <EVButton id="signout-button" className={classes.link} onClick={expireUser} disabled={isSignOutDisabled}>
          Sign out
        </EVButton>
      </EVPaper>
    </Draggable>
  );
};

SignoutBanner.propTypes = {
  t: PropTypes.func.isRequired,
  userDetails: PropTypes.shape().isRequired,
  bounds: PropTypes.shape().isRequired,
  position: PropTypes.shape().isRequired,
  handleDrag: PropTypes.func.isRequired,
  isSignOutDisabled: PropTypes.bool.isRequired,
};

export default compose(withTranslation())(SignoutBanner);
